import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

const useRevokeDataSharingConnection = (connectionId: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<void>({
    path: `/api/businesses/${business.id}/dataSharing/connections/${connectionId}/revoke`,
    method: HttpMethod.POST,
  }, options);
}

export default useRevokeDataSharingConnection;